import { render, staticRenderFns } from "./clauseList.vue?vue&type=template&id=b4986a20&"
import script from "./clauseList.vue?vue&type=script&lang=js&"
export * from "./clauseList.vue?vue&type=script&lang=js&"
import style0 from "./clauseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4986a20')) {
      api.createRecord('b4986a20', component.options)
    } else {
      api.reload('b4986a20', component.options)
    }
    module.hot.accept("./clauseList.vue?vue&type=template&id=b4986a20&", function () {
      api.rerender('b4986a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/clauseList.vue"
export default component.exports